import { render, staticRenderFns } from "./UserQualificationUpdate.vue?vue&type=template&id=ed5998c4&"
import script from "./UserQualificationUpdate.vue?vue&type=script&lang=js&"
export * from "./UserQualificationUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports